import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-128aaff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custCommPlan" }
const _hoisted_2 = {
  class: "text-wrapper",
  style: {"text-align":"left"}
}

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay } from '@/utils/date-format'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { h, ref } from 'vue'
import { ElMessage } from 'element-plus/es'
import { modalConfig } from './config/modal.config'
import PageModal from '@/components/PageModal.vue'
import { editPageData, getPageListData } from '@/service/main/system'
import { initEmptyParam } from '@/hooks/useInitParam'
import localCache from '@/utils/cache'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustCommPlan',
  setup(__props) {

initEmptyParam()
let query = {}
const route = useRoute()
const store = useStore()
const userInfo = store.state.login.userInfo
if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = { empIds }
    }
  }
  query = { ...query, createdTime: route.query.createdTime }
} else {
  query = { ...route.query }
}

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const pageInfo = ref({ pageNo: 1, pageSize: 10 })

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    createdTime: [toDay(), toDay()],
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    createdTime: [toDay(), toDay()],
    ...query,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)
const resetCb = () => {
  return queryParam.value
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)
const router = useRouter()

const handleFillClick = () => {
  const reportUrl = router.resolve({
    path: '/main/report/custCommPlan/fill'
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenWidth * 0.7

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const modalTitle = ref('新增')

let custCommPlanIds: Array<number> = []
let exploitAccounts: string
// 多选框选择事件
const handleSlectionChange = (value: any[]) => {
  custCommPlanIds = []
  exploitAccounts = ''
  for (const row of value) {
    custCommPlanIds.push(row.id)
    exploitAccounts += row.exploitAccount + ', '
  }
  exploitAccounts = exploitAccounts.substring(0, exploitAccounts.length - 2)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const handleBatchEditAccountBtnClick = () => {
  if (custCommPlanIds.length == 0) {
    ElMessage({
      message: '请勾选修改的数据',
      type: 'warning'
    })
    return
  }

  defaultInfo.value = { oldExploitAccount: exploitAccounts }
  modalTitle.value = '批量修改'
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleUpdateBatchData = async (formData: any) => {
  try {
    await editPageData('/main/custCommPlan/batch/update', {
      ...formData,
      ids: custCommPlanIds
    })
    store.dispatch('system/getPageListAction', {
      pageName: 'custCommPlan',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRef.value.dialogVisible = false
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const handleDetailData = (item: any) => {
  getPageListData('/main/custCommPlan/' + item.id, null).then((res) => {
    const reportUrl = router.resolve({
      path: '/main/report/custCommPlan/detail',
      query: {
        id: res.id,
        custType: res.custType,
        exploitAccount: res.exploitAccount,
        custName: res.custName,
        funds: res.funds,
        ageGroup: res.ageGroup,
        signExperience: res.signExperience,
        profitAndLoss: res.profitAndLoss,
        financialInvestment: res.financialInvestment,
        job: res.job,
        operateStyle: res.operateStyle,
        freeTime: res.freeTime,
        todayTrackCondition: res.todayTrackCondition,
        tmrTrackPlan: res.tmrTrackPlan,
        estimatedTxTime: res.estimatedTxTime,
        custCommPlanStocks: JSON.stringify(res.custCommPlanStocks),
        zone: res.zone,
        painAndResist: res.painAndResist,
        stockAge: res.stockAge,
        lifeAndWork: res.lifeAndWork,
        amountQuoted: res.amountQuoted,
        signStatus: res.signStatus,
        empName: res.empName
      }
    }).href

    // 获取屏幕的宽度和高度
    const screenWidth = window.screen.width
    const screenHeight = window.screen.height

    const width = screenWidth * 0.7
    const height = screenWidth * 0.7

    // 计算新窗口的左上角位置，使其居中
    const leftPosition = screenWidth / 2 - width / 2
    const topPosition = screenHeight / 2 - height / 2

    // 创建弹出窗口
    const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
    const popupWindow = window.open(reportUrl, '填报', options)
    if (popupWindow) {
      popupWindow.onbeforeunload = function () {
        const queryInfo = store.state.system.queryInfo
        pageContentRef.value?.getPageData(queryInfo)
      }
    }
  })
}

const handleSortChange = (value: any) => {
  let orderBy = value.prop
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const dialogTableVisible = ref(false)
const gridData = ref({})
const dialogVisible = ref(false)
const dialogContent = ref(String)
const handleCustType = (custType: any) => {
  dialogVisible.value = true
  switch (custType) {
    case 'A类':
      dialogContent.value =
        'A类：\n' +
        '\n' +
        '1、资金量：30W以上；\n' +
        '\n' +
        '2、年龄段：50岁-65岁；\n' +
        '\n' +
        '3、签约经历：0次和1次；\n' +
        '\n' +
        '4、亏损情况情况：20%以内；\n' +
        '\n' +
        '5、金融投资经历（除基金以外）：无；\n' +
        '\n' +
        '6、职业：退休，开公司，做生意，银行，\n' +
        '\n' +
        '大型餐饮店（5个服务员以上，店面200平以上）；\n' +
        '\n' +
        '7、操作风格和喜好：短线：1个月以内；'
      break
    case 'B类':
      dialogContent.value =
        'B类：\n' +
        '\n' +
        '1、资金量：20W-30W ；\n' +
        '\n' +
        '2、年龄段：40岁-50岁；\n' +
        '\n' +
        '3、签约经历：2次；\n' +
        '\n' +
        '4、亏损情况情况：20-50%；\n' +
        '\n' +
        '5、金融投资经历（除基金以外）：2种或1种；\n' +
        '\n' +
        '6、职业：医生，老师，公务员，事业单位，国企，\n' +
        '\n' +
        '做工程，公司高管，账户资金20万以上的全职太太；'
      break
    case 'C类':
      dialogContent.value =
        'C类：\n' +
        '\n' +
        '1、资金量：20W以内；\n' +
        '\n' +
        '2、年龄段：40岁以下以及60岁以上；\n' +
        '\n' +
        '3、签约经历：3次以上/一次及以内退费经历；\n' +
        '\n' +
        '4、亏损情况情况：50%以上；\n' +
        '\n' +
        '5、金融投资经历（除基金以外）：3种以上；\n' +
        '\n' +
        '6、职业：开小商店（无服务员），卖早餐的；'
      break
    case 'D类':
      dialogContent.value =
        'D类：1、职业:出租车司机，农民，工厂打工类，\n' +
        '\n' +
        '20万以内的全职太太，外卖员，做微商的，快递员 ；'
      break
    default:
      ''
      break
  }
}

const handleStockCount = (custCommPlanId: number) => {
  getPageListData(
    '/main/custCommPlanStock/getByCustCommPlanId/' + custCommPlanId,
    null
  ).then((res) => {
    dialogTableVisible.value = true
    gridData.value = res
  })
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "custCommPlan",
        downFilename: "客户沟通计划表.xlsx",
        onFillBtnClick: handleFillClick,
        onBatchEditAccountBtnClick: handleBatchEditAccountBtnClick,
        onDownBtnClick: _unref(handleDownBtnClick),
        onSelectionChange: handleSlectionChange,
        onDetailClick: handleDetailData,
        onSortChange: handleSortChange
      }, {
        custType: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handleCustType(scope.row.custType))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.custType), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        stockCount: _withCtx((scope) => [
          _createVNode(_component_el_link, {
            type: "warning",
            href: "javascript:;",
            onClick: ($event: any) => (handleStockCount(scope.row.id)),
            disabled: 
            scope.row.stockCount === null || scope.row.stockCount === '0'
          
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])
        ]),
        _: 1
      }, 8, ["contentTableConfig", "onDownBtnClick"]),
      _createVNode(PageModal, {
        ref_key: "pageModalRef",
        ref: pageModalRef,
        defaultInfo: defaultInfo.value,
        modalConfig: _unref(modalConfig),
        title: modalTitle.value,
        pageName: "custCommPlan",
        onUpdateBatchData: handleUpdateBatchData
      }, null, 8, ["defaultInfo", "modalConfig", "title"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      title: "温馨提示：客户分类",
      width: "30%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(dialogContent.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogTableVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogTableVisible).value = $event)),
      title: "股票情况"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: gridData.value,
          stripe: "true",
          border: "true",
          "header-cell-style": { background: '#eef1f6', color: '#606266' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "stockCode",
              label: "股票代码"
            }),
            _createVNode(_component_el_table_column, {
              property: "shares",
              label: "股数（股）"
            }),
            _createVNode(_component_el_table_column, {
              property: "buyinTime",
              label: "买进时间"
            }),
            _createVNode(_component_el_table_column, {
              property: "cost",
              label: "成本"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})